// Mock data for JP Joinery website

export const businessInfo = {
  name: "JP Joinery",
  tagline: "Bespoke Fitted Furniture Designed Around You",
  description: "Expertly crafted wardrobes, kitchens and custom solutions in Hull and surrounding areas.",
  phone: "07908 066326",
  email: "jpjoinerycarpentry@gmail.com",
  address: {
    street: "Gibson Lane",
    area: "",
    city: "North Ferriby",
    postcode: "HU14 3LH"
  },
  rating: 5.0,
  reviewCount: 38,
  website: "https://inner-style.co.uk",
  hours: "Closes 8pm"
};

export const services = [
  {
    id: 1,
    title: "Fitted Wardrobes & Bedrooms",
    description: "Made-to-measure bedroom storage designed to maximise space beautifully.",
    icon: "Shirt",
    image: "https://customer-assets.emergentagent.com/job_2e426097-2416-4bdd-b0b2-486650f29584/artifacts/657tsvbf_23.jpg"
  },
  {
    id: 2,
    title: "Bespoke Kitchens",
    description: "High-quality fitted kitchens tailored to your lifestyle.",
    icon: "ChefHat",
    image: "https://customer-assets.emergentagent.com/job_2e426097-2416-4bdd-b0b2-486650f29584/artifacts/ie3311xz_4.jpg"
  },
  {
    id: 3,
    title: "Home Offices & Desks",
    description: "Smart workspace solutions built around your room dimensions.",
    icon: "Laptop",
    image: "https://customer-assets.emergentagent.com/job_2e426097-2416-4bdd-b0b2-486650f29584/artifacts/ktrd1pe3_office.jpeg"
  },
  {
    id: 4,
    title: "Custom Solutions",
    description: "Media walls, alcove units, under-stair storage and more.",
    icon: "Package",
    image: "https://customer-assets.emergentagent.com/job_inner-style-preview/artifacts/rhfl3z4s_1.jpg"
  }
];

export const features = [
  {
    id: 1,
    title: "5 Star Rated",
    description: "Genuine customer reviews",
    icon: "Star"
  },
  {
    id: 2,
    title: "Brilliant Quality",
    description: "Premium materials and craftsmanship",
    icon: "Award"
  },
  {
    id: 3,
    title: "Expert Installation",
    description: "Professional fitting team",
    icon: "Hammer"
  },
  {
    id: 4,
    title: "Designed to Detail",
    description: "Precision measurements and planning",
    icon: "Ruler"
  },
  {
    id: 5,
    title: "On Time",
    description: "Reliable project completion",
    icon: "Clock"
  },
  {
    id: 6,
    title: "Local Business",
    description: "Trusted Hull-based company",
    icon: "MapPin"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "David S.",
    rating: 5,
    text: "Brilliant price, quality and service from start to finish. From my first conversation with James, through the design process, to the fitting, the project was managed brilliantly. Many thanks also to Lewis, the installer, who worked tirelessly to get it installed, to an excellent standard.",
    date: "1 year ago",
    service: "Kitchen Installation"
  },
  {
    id: 2,
    name: "Kirstin Allen",
    rating: 5,
    text: "Totally thrilled with the wardrobe and desk installed by Brian and his team. They worked wonders within a smallish area and limited budget, and it has worked out better than I was expecting - pictures don't do it justice.",
    date: "1 year ago",
    service: "Wardrobe & Desk"
  },
  {
    id: 3,
    name: "Hayley Barker",
    rating: 5,
    text: "This is the second job that James and his team have completed for me. Fitted wardrobes in our main bedroom. I am over the moon with them - high quality and fitted perfectly. James always plans to the smallest detail and I wouldn't hesitate in using them again.",
    date: "10 months ago",
    service: "Fitted Wardrobes"
  },
  {
    id: 4,
    name: "Karl Svenson",
    rating: 5,
    text: "I couldn't be happier with our new kitchen! From start to finish, the experience was nothing short of fantastic. The design team truly listened to our needs and created a beautiful, functional space that exceeded my expectations.",
    date: "1 year ago",
    service: "Kitchen"
  },
  {
    id: 5,
    name: "Jamie Carr",
    rating: 5,
    text: "Just had a kitchen fitted by the team who worked around my autistic son's need for routine. Lewis (kitchen fitter) and the other trades were excellent and very professional. Would 100% recommend and wouldn't hesitate to use again.",
    date: "6 months ago",
    service: "Kitchen"
  },
  {
    id: 6,
    name: "Scott Wilson",
    rating: 5,
    text: "First time using them after recommendations. Excellent service throughout the whole process and the quality of work was second to none. Always on time and worked incredibly hard! Couldn't recommend them highly enough!",
    date: "8 months ago",
    service: "Fitted Furniture"
  },
  {
    id: 7,
    name: "Steven Dick",
    rating: 5,
    text: "Fitted wardrobes supplied and fitted. Excellent workmanship. Darren our fitter was polite, clean and tidy - his workmanship couldn't be faulted from start to finish. Really pleased with quality of work.",
    date: "1 year ago",
    service: "Fitted Wardrobes"
  },
  {
    id: 8,
    name: "Danielle Forbes",
    rating: 5,
    text: "Absolutely over the moon with our large media style wall in our living room and fitted wardrobe - great service right from design to installation, amazing quality and workmanship. Have used them for previous work and would not go anywhere else.",
    date: "2 years ago",
    service: "Media Wall & Wardrobe"
  },
  {
    id: 9,
    name: "Celia Standen",
    rating: 5,
    text: "Highly recommend James and his team. Listened to what I wanted and made really good suggestions, and very patient and accommodating when I changed my mind! Workmanship to a very high standard, am delighted with my beautiful new kitchen.",
    date: "10 months ago",
    service: "Kitchen"
  },
  {
    id: 10,
    name: "Georgina Walker",
    rating: 5,
    text: "I have used James for 3 jobs now over the past 5 years. He is always polite and nothing is too much trouble for him. His workmanship is always amazing. Always tidy and on time. Would highly recommend the team.",
    date: "1 year ago",
    service: "Multiple Projects"
  },
  {
    id: 11,
    name: "Michael Wheatley",
    rating: 5,
    text: "Had a full kitchen install designed & fitted by James & the team. Great experience from start to finish & everyone involved went the extra mile to ensure our kitchen is exactly as we wanted. Very competitive on price.",
    date: "3 years ago",
    service: "Kitchen"
  },
  {
    id: 12,
    name: "Lynn Grindell",
    rating: 5,
    text: "Cannot recommend them enough. So happy with the kitchen and Lewis the kitchen fitter is absolutely brilliant!",
    date: "2 years ago",
    service: "Kitchen"
  }
];

export const process = [
  {
    id: 1,
    step: "01",
    title: "Initial Consultation",
    description: "We visit your home to understand your needs, measure the space, and discuss design ideas."
  },
  {
    id: 2,
    step: "02",
    title: "Design & Planning",
    description: "Our team creates detailed plans and 3D visualisations tailored to your requirements."
  },
  {
    id: 3,
    step: "03",
    title: "Manufacture",
    description: "Your bespoke furniture is carefully crafted using premium materials in our workshop."
  },
  {
    id: 4,
    step: "04",
    title: "Professional Installation",
    description: "Expert fitting by our skilled team, ensuring perfect results and minimal disruption."
  }
];

export const galleryItems = [
  {
    id: 1,
    category: "Home Bars",
    title: "Home Bar with Oak Worktop & Beer Taps",
    image: "https://customer-assets.emergentagent.com/job_55c593a9-e2a5-421c-8db9-073c51e78637/artifacts/4lewx0q9_IMG-20260309-WA0002.jpg"
  },
  {
    id: 2,
    category: "Stairs & Balustrades",
    title: "Floating Staircase with Oak Slat Balustrade",
    image: "https://customer-assets.emergentagent.com/job_55c593a9-e2a5-421c-8db9-073c51e78637/artifacts/b65jd38y_IMG-20260309-WA0003.jpg"
  },
  {
    id: 3,
    category: "Construction",
    title: "Roof Trusses Installation",
    image: "https://customer-assets.emergentagent.com/job_55c593a9-e2a5-421c-8db9-073c51e78637/artifacts/2bhsku4z_IMG-20260309-WA0004.jpg"
  },
  {
    id: 4,
    category: "JP Joinery",
    title: "JP Joinery Van on Site",
    image: "https://customer-assets.emergentagent.com/job_55c593a9-e2a5-421c-8db9-073c51e78637/artifacts/iym4an6l_IMG-20260309-WA0005.jpg"
  },
  {
    id: 5,
    category: "Flooring",
    title: "Herringbone Oak Flooring",
    image: "https://customer-assets.emergentagent.com/job_55c593a9-e2a5-421c-8db9-073c51e78637/artifacts/omrocyoh_IMG-20260309-WA0006.jpg"
  },
  {
    id: 6,
    category: "Commercial",
    title: "Reception with Slatted Feature Wall",
    image: "https://customer-assets.emergentagent.com/job_55c593a9-e2a5-421c-8db9-073c51e78637/artifacts/0lyhdwf9_IMG_20260309_200744_912.jpg"
  },
  {
    id: 7,
    category: "Doors",
    title: "Oak Front Door with Glass Side Panels",
    image: "https://customer-assets.emergentagent.com/job_55c593a9-e2a5-421c-8db9-073c51e78637/artifacts/xrzk98wa_IMG_20260309_200746_993.jpg"
  },
  {
    id: 8,
    category: "Doors",
    title: "Contemporary Oak Front Door",
    image: "https://customer-assets.emergentagent.com/job_55c593a9-e2a5-421c-8db9-073c51e78637/artifacts/8vl7c6e8_IMG_20260309_200747_832.jpg"
  },
  {
    id: 9,
    category: "Stairs & Balustrades",
    title: "Oak & Glass Staircase with Slat Detail",
    image: "https://customer-assets.emergentagent.com/job_55c593a9-e2a5-421c-8db9-073c51e78637/artifacts/7t2f4me8_IMG_20260309_200749_277.jpg"
  },
  {
    id: 10,
    category: "Commercial",
    title: "Cafe Bar Fit-Out with Oak Worktop",
    image: "https://customer-assets.emergentagent.com/job_55c593a9-e2a5-421c-8db9-073c51e78637/artifacts/zyqfn0mo_IMG_20260309_200752_955.jpg"
  },
  {
    id: 11,
    category: "Kitchens",
    title: "Grey Shaker Kitchen with Oak Worktop",
    image: "https://customer-assets.emergentagent.com/job_55c593a9-e2a5-421c-8db9-073c51e78637/artifacts/2cfc37rs_IMG_20260309_200753_781.jpg"
  },
  {
    id: 12,
    category: "Kitchens",
    title: "Dark Grey Handleless Kitchen",
    image: "https://customer-assets.emergentagent.com/job_55c593a9-e2a5-421c-8db9-073c51e78637/artifacts/mdazpl6t_IMG_20260309_200756_088.jpg"
  }
];

export const faqs = [
  {
    id: 1,
    question: "How much does fitted furniture cost?",
    answer: "Costs vary depending on size, materials, and complexity. We provide free, no-obligation quotes after measuring your space and understanding your requirements."
  },
  {
    id: 2,
    question: "How long does installation take?",
    answer: "Most projects are completed within 1-3 days, depending on the scope. We'll give you a clear timeline during the planning stage."
  },
  {
    id: 3,
    question: "What materials do you use?",
    answer: "We use only high-quality materials including premium MDF, solid wood, and durable laminates. All materials are sourced from trusted suppliers."
  },
  {
    id: 4,
    question: "Do you offer a warranty?",
    answer: "Yes, all our fitted furniture comes with a comprehensive warranty covering workmanship and materials."
  },
  {
    id: 5,
    question: "What areas do you cover?",
    answer: "We're based in Hull and serve the surrounding areas including East Yorkshire and North Lincolnshire."
  }
];

export const projectTypes = [
  "Fitted Wardrobes",
  "Bespoke Kitchen",
  "Home Office",
  "Storage Solutions",
  "Other"
];

// Mock function to simulate form submission
export const submitContactForm = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Mock form submission:", formData);
      localStorage.setItem('lastEnquiry', JSON.stringify({
        ...formData,
        submittedAt: new Date().toISOString()
      }));
      resolve({
        success: true,
        message: "Thank you! We'll be in touch soon."
      });
    }, 1000);
  });
};
